angular.module('tikonApp').directive('eoCalendar', ['DateUtil', '$mdDialog', '$timeout', 'TimingInfo', '$localStorage', '$state', 'CompanyCustom', 'DateUtils', 'Principal', 'ENV',
    function (dateUtil, $mdDialog, $timeout, timingInfo, $localStorage, $state, CompanyCustom, DateUtils, Principal, ENV) {
        return {
            restrict: 'A',
            scope: {calendarFilter: '=', refreshTimingInfo: '&?', accessLevel: '<?', lastUpdate: '='},
            transclude: true,
            templateUrl: 'app/components/eyeson/calendar/eyeson.calendar.template.html',

            link: function ($scope, $element, $attrs, $controller) {

                var scheduleIsLoaded = false;
                var eventsInited = false;
                var onCratingNewEvent = false;
                var serviceId;
                var canSeeReserve = true;
                var currentCompany = null;
                var appVersion = 'v3';
                var hasNewReserveAuthority = true;
                //console.log($scope.schedulerApi);
                //  $scope.schedulerApi.refreshScheduler = refreshScheduler;
                //adjust size of a scheduler
                $timeout(function () {
                    if ($scope.calendarFilter) {
                        CompanyCustom.getCurrentCompany().query().$promise.then(function (com) {
                            currentCompany = com;
                            appVersion = com.appVersion;
                            initSchedule();
                            configScheduler();
                        })
                    }
                }, 0);

                $timeout(function () {
                    $scope.$watch('lastUpdate', function (serviceItemId) {
                        if ($scope.lastUpdate && $scope.calendarFilter && $scope.calendarFilter.serviceList && $scope.calendarFilter.serviceList.length > 0)
                            refreshScheduler();
                    });


                    /*   $scope.$watch('calendarFilter', function (serviceItemId) {
                           if ($scope.calendarFilter.serviceList && $scope.calendarFilter.serviceList.length > 0)
                               refreshScheduler();
                       });*/
                }, 50);


                function refreshScheduler() {
                    //   alert('refresh called');
                    initSchedule();
                    configScheduler();
                    setSchedulerDataSource();
                }

                function checkAuthority() {

                    hasNewReserveAuthority = true;

                    // Principal.hasAuthority("ROLE_RESERVATION_MODIFIER").then(function (has) {
                    //     if(has)
                    //         hasNewReserveAuthority = true;
                    //     else
                    //         hasNewReserveAuthority = false;
                    // })
                }

                function configScheduler() {


                    checkAuthority();
                    scheduleIsLoaded = false;
                    var first_hour = 0;
                    var last_hour = 24;
                    if ($scope.calendarFilter) {
                        if ($scope.calendarFilter.firstHour || $scope.calendarFilter.firstHour === 0)
                            first_hour = $scope.calendarFilter.firstHour;
                        else
                            first_hour = $scope.calendarFilter.firstHour = 6;
                        if ($scope.calendarFilter.lastHour && $scope.calendarFilter.lastHour <= 24)
                            last_hour = $scope.calendarFilter.lastHour;
                        else
                            last_hour = $scope.calendarFilter.lastHour = 24;

                    }
                    var limit_start = new Date();
                    // var limit_end = new Date('3000-01-01')
                    var limit_end = DateUtils.newDate('3000-01-01');

                    scheduler.config.first_hour = first_hour;
                    scheduler.config.last_hour = last_hour;
                    scheduler.config.limit_start = limit_start;
                    scheduler.config.limit_end = limit_end;
                    scheduler.config.limit_view = true;


                    clearSchedule();
                }

                function onDoubleClick(id, e) {
                    if (!onCratingNewEvent)
                        scheduler.showLightbox(id);
                }


                function convertWeekNameToOrder(day) {
                    var index = DAYS_VALUES.indexOf(day);
                    if (index == 0) return 6;
                    return index - 1;

                }

                function clearSchedule() {
                    scheduler.clearAll();
                    scheduler.deleteMarkedTimespan();
                }

                function makeListToString(list) {
                    var retString = "";
                    if (list && list.length > 0) {
                        angular.forEach(list, function (item) {
                            retString = retString + "," + item;
                        })
                    } else {
                        return 'any';
                    }

                    return retString;
                }


                function setSchedulerDataSource() {


                    scheduler.setLoadMode("week");

                    var servants = $scope.calendarFilter.servantList;

                    // if(servants && servants.length>1 && $scope.calendarFilter.selectedServant != 'SHOW_ALL')
                    // {
                    //     var old = servants ;
                    //     servants = [];
                    //     servants.push(old[0]);
                    // }

                    var services = [];
                    if ($scope.calendarFilter.filterServices)
                        services = $scope.calendarFilter.serviceList;

                    if (currentCompany) {
                        scheduler.load(ENV.API_BASE_URL + "api/client/getSchedulerEventByFilter/" + makeListToString(services) + "/" + makeListToString(servants) + "/" + makeListToString($scope.calendarFilter.reserveTypes) + "/" + currentCompany.id, "json", function (data) {
                        });
                        refreshBlockTime();
                    }

                }

                function refreshBlockTime() {
                    var types = [];
                    types.push("FREE");

                    var serviceListId = $scope.calendarFilter.serviceList;
                    if ($scope.calendarFilter.selectedServantServiceList) {
                        serviceListId = [];
                        for (var i = 0; i < $scope.calendarFilter.selectedServantServiceList.length; i++) {
                            if ($scope.calendarFilter.selectedServantServiceList[i].serviceMode && $scope.calendarFilter.selectedServantServiceList[i].serviceMode == 'EVENT')
                                continue;
                            else
                                serviceListId.push($scope.calendarFilter.selectedServantServiceList[i].id);
                        }

                    }
                    var selectedServantId = [];
                    for (var i = 0; i < $scope.calendarFilter.servantList.length; i++) {
                        // selectedServantId.push($scope.calendarFilter.servantList[i].id);
                        selectedServantId.push($scope.calendarFilter.servantList[i]);
                    }

                    // if($scope.calendarFilter.selectedServant)
                    // {
                    //     if($scope.calendarFilter.selectedServant == 'SHOW_ALL')
                    //     {
                    //         for(var i=0;i<$scope.calendarFilter.servantList.length;i++)
                    //         {
                    //             selectedServantId.push($scope.calendarFilter.servantList[i].id);
                    //         }
                    //     }
                    //     else
                    //         selectedServantId.push($scope.calendarFilter.selectedServant);
                    // }

                    var multiServant = false;
                    if (selectedServantId.length > 1)
                        multiServant = true;
                    scheduler._set_block_url(ENV.API_BASE_URL + "api/getScheduledFreeDayTimesByFilter/" + makeListToString(serviceListId) + "/" + makeListToString(selectedServantId) + "/" + makeListToString(types) + "/" + $scope.calendarFilter.firstHour + "/" + $scope.calendarFilter.lastHour, multiServant);
                    // scheduler._load_block_time();

                }

                function AddNewTimeSession(ev) {
                    var timeSpan = {
                        startTime: DateUtils.newDate(ev.start_date),
                        endTime: DateUtils.newDate(ev.end_date),
                        serviceItemId: serviceId
                    };
                    timingInfo.addNewTimeSession().save(timeSpan);

                    onCratingNewEvent = false;

                }

                function setEventStyle(start, end, ev) {
                    var retclass = "event-box ";

                    if (ev.serviceImage) {
                        retclass = retclass + "Calendar-" + ev.serviceImage;
                    } else {
                        retclass += "COLOR0";
                    }
                    if (ev.orderBagStatusList && ev.orderBagStatusList.length > 0) {

                    } else {
                        retclass += ' inactive'
                    }
                    return retclass;

                    //if(ev.hidden)
                    //{
                    //    return "scheduler_hidden_event";
                    //}


                    //if(ev.reserveRequestCount>0)
                    //{
                    //    return "scheduler_has_orders_to_confirm"
                    //}
                    //if(ev.waitToPayRequestCount>0)
                    //{
                    //    return "scheduler_has_orders_to_pay"
                    //}
                    //if (!ev.enable) {
                    //    return "scheduler_not_enable";
                    //}
                    //if (!ev.capacity > 0) {
                    //    return "scheduler_no_capacity";
                    //
                    //}
                    //if(ev.confirmedRequestCount>0)
                    //{
                    //    return "scheduler_has_confirmed_orders"
                    //}


                }

                function initSchedule() {

                    //styling for dhtmlx scheduler
                    $element.addClass("dhx_cal_container schedule_container");

                    scheduler.config.start_on_monday = false;
                    //scheduler.config.show_loading = true;
                    //init scheduler
                    //
                    scheduler.templates.event_class = setEventStyle;

                    var mode = "week";
                    var start_date = new JDate();
                    if ($localStorage.timeline_mode != undefined)
                        mode = $localStorage.timeline_mode;

                    if ($localStorage.timeline_startDate != undefined) {
                        start_date.date[0]
                        var d = $localStorage.timeline_startDate;
                        if (d.date != undefined && d.date[0] != undefined)
                            start_date = new JDate(d.date[0], d.date[1], d.date[2]);
                    }
                    if ($localStorage.calendarFilter.selectionMode) {
                        mode = $localStorage.calendarFilter.selectionMode;
                        setWeekTabButtonStatus($localStorage.calendarFilter.selectionMode);

                    }

                    if (screen.width <= 480) {
                        mode = "day";
                        scheduler.init($element[0], start_date, "day");
                    }
                    scheduler.init($element[0], start_date, mode);

                    scheduler.config.icons_select = [
                        //"icon_details",
                        //
                        //"icon_delete"
                    ];

                    scheduler.attachEvent("onClick", onDoubleClick);
                    scheduler.attachEvent("onEventAdded", function (e, event) {
                        //   AddNewTimeSession(event);
                    });
                    scheduler.attachEvent("onEventCreated", function (e) {
                        onCratingNewEvent = true;
                    });
                    scheduler.attachEvent("onEventCancel", function (e) {
                        onCratingNewEvent = false;
                    });
                    scheduler.attachEvent("onBeforeViewChange", function (old_mode, old_date, mode, date) {
                        $localStorage.timeline_mode = mode;

                        $localStorage.timeline_startDate = date;
                        //any custom logic here
                        return true;
                    });
                    //   scheduler.templates.event_text = eventTextTemplate;
                    scheduler.templates.tooltip_text = eventTooltipTemplate;
                    scheduler.renderEvent = function (container, ev) {

                        var container_width = container.style.width; // e.g. "105px"
                        var colorstyle = '';

                        // move section
                        var html = "<div class='dhx_event_move my_event_move' style='width: " +
                            container_width + "'></div>";

                        // container for event's content
                        html += "<div class='my_event_body'>";
                        html += "<div class='event_first_line'>";
                        html += "<span class='event_date'>";
                        //two options here:show only start date for short events or start+end for long
                        if ((ev.end_date - ev.start_date) / 60000 > 40) {//if event is longer than 40 minutes
                            html += scheduler.templates.event_header(ev.end_date, ev.start_date, ev);
                            html += "</span><br/>";
                        } else {

                            // var w = DateUtils.changeJDateTimeToTehran(ev.start_date);
                            html += scheduler.templates.event_date(ev.start_date) + "</span>";
                        }

                        html += "</div>";

                        html += makeCustomerHtml(ev.customerName, ev.customerPhoneNumber, ev.multiCustomer);

                        if ((ev.end_date - ev.start_date) / 60000 > 40) {//if event is longer than 40 minutes
                            html += makeServantTitleHtml(ev.servantTitle);

                        }
                        if ((ev.end_date - ev.start_date) / 60000 >= 60) {
                            html += makeTagsHtml(ev.tags);
                        }

                        // displaying event's text
                        html += "<span>" + scheduler.templates.event_text(ev.start_date, ev.end_date, ev) +
                            "</span>" + "</div>";

                        // resize section
                        html += "<div class='dhx_event_resize my_event_resize' style='width: " +
                            container_width + "'></div>";

                        container.innerHTML = html;
                        return true; //required, true - display a custom form, false - the default form
                    };
                    dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip pl-tooltip';
                    dhtmlXTooltip.config.timeout_to_display = 500;
                    scheduler.config.separate_short_events = true;
                    //scheduler.config.hour_size_px = 70;
                    dhtmlXTooltip.config.delta_x = 15;
                    dhtmlXTooltip.config.delta_y = -20;
                    function eventTextTemplate(start, end, event) {
                        return '<span style="background-color: yellow">' + event.text + '-' + ' </span><span style="color:#aed581"> <span  class="glyphicon glyphicon-user">  </span>' + event.capacity + '</span>';


                    }

                    function setWeekTabButtonStatus(selectionMode) {
                        var element = document.getElementById('week_tab');
                        if (selectionMode && selectionMode == 'day') {
                            if (!element.classList.contains('hide-week-tab'))
                                element.classList.add("hide-week-tab");
                        } else {
                            if (element.classList.contains('hide-week-tab'))
                                element.classList.remove("hide-week-tab");
                        }
                    }

                    function eventTooltipTemplate(start, end, event) {


                        var time = "<p style='text-align:center;font-weight: bold'>" + getTimeFormat(end) + " - " + getTimeFormat(start) +
                            "</p>";
                        var status = "<p class='pl-tooltip-status pl-tooltip-status-" + event.orderBagStatus + "'>" + findStatusTitle(event) + "</p>";
                        var tooltipHtml = '<div class="scheduler_tooltip" >'
                            + '<div class="pl-tooltip-header">'
                            + time
                            + status
                            + '</div>' +

                            '<p>' + event.serviceTitle + '</p>';

                        if (event.servantTitle)
                            tooltipHtml += '<p>' + event.servantTitle + '</p>';

                        if (event.customerName)
                            tooltipHtml += '<p style="font-weight: bold">' + event.customerName + '</p>';


                        tooltipHtml += '</div>';
                        return tooltipHtml;
                    };
                    var lightBoxForm = document.getElementById("light_box_form");
                    isShowing = false;
                    scheduler.showLightbox = function (id) {
                        var ev = scheduler.getEvent(id);


                        ev.updateEvent = function () {
                            scheduler.updateEvent(id);
                        };
                        if (!isShowing) {

                            showCustomLightBox(ev, $scope.refreshTimingInfo);
                            isShowing = true;
                        }
                        //     scheduler.startLightbox(id, lightBoxForm);
                        //...'here you need to set values in the form'...
                        //document.getElementById("some_input").value = ev.text;
                    }
                    scheduler.showLightbox_addNew = function (id) {
                        var date_to_add = scheduler._make_date_time_from_splice_id(id);
                        var _dialogData = {};

                        _dialogData.start_date = date_to_add;
                        _dialogData.servantId = $scope.calendarFilter.selectedServant;
                        _dialogData.servantTitle = $scope.calendarFilter.servantTitle;
                        gotoNewReserve(_dialogData);
                        // showCustomLightBox(_dialogData, $scope.refreshTimingInfo);
                        // isShowing = true;

                        //     scheduler.startLightbox(id, lightBoxForm);
                        //...'here you need to set values in the form'...
                        //document.getElementById("some_input").value = ev.text;
                    }

                    //clearSchedule();
                    //scheduler.updateView();
                    //clearSchedule();
                }

                gotoNewReserve = function (_dialogData) {
                    // $mdDialog.hide();
                    if (!hasNewReserveAuthority)
                        return;

                    var s_date, e_date = null;
                    if (_dialogData.start_date) {
                        s_date = _dialogData.start_date;


                        //FUCK REGIME !!!!!!!!!!
                        //Check Date - 6 month of the year
                        var pDate = DateUtils.convertToPersianDate(s_date);

                        if (pDate.getMonth() < 7) {
                            s_date = new Date(s_date.setHours(s_date.getHours()));
                        }
                        s_date = s_date.toISOString()

                    }
                    if (_dialogData.end_date)
                        e_date = _dialogData.end_date.toISOString();


                    if (appVersion == 'v3') {
                        //majid alan
                        $state.go('supplierPanel-v2.new-reserve-modal', {
                            serviceItemId: _dialogData.serviceItemId,
                            servantId: _dialogData.servantId,
                            start_date: s_date,
                            end_date: e_date,
                            hasCustomTime: true
                        });

                    }

                    if (appVersion == 'v2') {
                        $state.go('supplierPanel.new-reserve-modal', {
                            serviceItemId: _dialogData.serviceItemId,
                            servantId: _dialogData.servantId,
                            start_date: s_date,
                            end_date: e_date,
                            hasCustomTime: true
                        });

                    }

                    /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                     serviceItemId: serviceItemId,
                     timeSessionId: dialogData.id
                     });

                     window.open(url,'_blank');*/
                    //   window.open(url,'_self');

                }

                function getTimeFormat(d) {
                    var date = DateUtils.newDate(d);
                    // date = DateUtils.toTehranTime(date);

                    date = moment(date);

                    return date.format("HH:mm");
                }

                function makeServantTitleHtml(servantTitle) {
                    var retHtml = "";
                    if (servantTitle) {
                        retHtml += "<div class='servant-section'> <span class='material-icons' style='font-size: 13px ; float:right'>assignment_ind</span>" + "<span class='servant-title-on-event' >"
                            + servantTitle + "</span> </div>";
                    }
                    return retHtml;

                }

                function makeTagsHtml(tags) {

                    var retHtml = "";


                    if (tags && tags.length) {
                        if(tags[0]) retHtml+= "<span>"+tags[0].tag+"</span>"
                        if(tags[1]) retHtml+= "<span>"+tags[1].tag+"</span>"
                        if(tags.length > 2) retHtml+= "<span>+"+ (tags.length-2) +"</span>"
                        return '<div class="orderbag-tags">'+retHtml+'</div>'
                    }
                    else  return ""

                }

                function makeCustomerHtml(customerName, customerPhone, isMultiCustomer) {
                    var retHtml = "";
                    if (customerName) {
                        retHtml += "<div class='servant-section'> <span class='material-icons' style='font-size: 13px ; float:right'>person</span>" + "<span class='customer-title-on-event' >"
                            + customerName + "</span> </div>";
                    }


                    return retHtml;

                }

                function findStatusTitle(event) {
                    switch (event.orderBagStatus) {
                        case 1 :
                            return 'تائید شده';
                        case 5 :
                            return 'درخواست رزرو';
                        case 6 :
                            return 'در انتظار پرداخت';
                    }
                }

                function showCustomLightBox(dialogData, refreshTimingInfoMethod) {

                    $mdDialog.show({
                        locals: {dialogData: dialogData, refreshTimingInfoMethod: refreshTimingInfoMethod},
                        controller: TimeSessionDetailController,
                        controllerAs: '$ctrl',
                        templateUrl: 'app/components/eyeson/calendar/eyeson.scheduler-time-session-dialog.template.html',
                        parent: angular.element(document.body),
                        targetEvent: dialogData,
                        clickOutsideToClose: true,
                        fullscreen: false// Only for -xs, -sm breakpoints.
                    })
                        .then(function (ev) {

                            isShowing = false;


                        }, function () {

                            isShowing = false;
                        });
                };
                var TimeSessionDetailController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
                    var $ctrl = this;
                    $ctrl.dialogData = dialogData;
                    $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;
                    //$ctrl.dialogData = {
                    //    id: dialogData.id,
                    //    price: dialogData.price,
                    //    capacity: dialogData.capacity,
                    //    enable: dialogData.enable,
                    //    discount: dialogData.discount,
                    //    isNew:dialogData.isNew
                    //};

                    var startDate = new JDate(dialogData.start_date);
                    // var startTime = toDateTimeTehranZone(dialogData.start_date);
                    var endDate = null;
                    var endTime = null;
                    if (dialogData.end_date)
                        endDate = new JDate(dialogData.end_date);
                    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                    if (startDate) {
                        $ctrl.title = startDate.format('dddd DD MMMM ');
                        $ctrl.title += formatTime(startDate);
                        if (endDate)
                            $ctrl.title += ' تا ' + formatTime(endDate);


                    }

                    function formatTime(time) {

                        var hour = time.format('HH');
                        var minute = time.format('SS');

                        hour = twoDigitFormat(hour);
                        minute = twoDigitFormat(minute);

                        return hour + ":" + minute;
                    }

                    function twoDigitFormat(input) {

                        var str = input.toString();
                        if (str.length < 2)
                            str = "0" + str;

                        return str;
                    }

                    function toDateTimeTehranZone(date) {
                        var x = new JDate(date);
                        var y = x._d;
                        var inputDate = new moment(y);
                        var tehranTime = inputDate.tz("Asia/Tehran");
                        return tehranTime;
                    }


                    $ctrl.hideDialog = function () {
                        $mdDialog.hide();
                    };

                    $ctrl.cancelDialog = function () {
                        $mdDialog.cancel();
                    };
                    $ctrl.copyTSimilarTimes = function () {
                        if (confirm("در صورت تایید ، خصوصیات این زمان در دیگر زمانهای این سرویس که ساعت مشابهی دارند کپی می شود. آیا اطمینان دارید؟")) {
                            TimingInfo.updateToSimilarTimeSessions($ctrl.dialogData.id).get(function () {
                                alert("تغییرات با موفقیت انجام شد. برای مشاهده دکمه بازیابی تقویم کاری را بزنید")
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        }
                    }

                    $ctrl.gotoNewReserve = function (serviceItemId) {

                        $mdDialog.hide();
                        if (appVersion == 'v3') {
                            $state.go('supplierPanel-v2.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
                                end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
                            });
                        }
                        if (appVersion == 'v2') {
                            $state.go('supplierPanel.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
                                end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
                            });
                        }
                        /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                         serviceItemId: serviceItemId,
                         timeSessionId: dialogData.id
                         });

                         window.open(url,'_blank');*/
                        //   window.open(url,'_self');

                    }

                    $ctrl.gotoNewReserve_flex = function () {
                        $mdDialog.hide();

                        var s_date, e_date = null;
                        if (dialogData.start_date)
                            s_date = dialogData.start_date.toISOString();
                        if (dialogData.end_date)
                            e_date = dialogData.end_date.toISOString();


                        if (appVersion == 'v3') {
                            $state.go('supplierPanel-v2.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: s_date,
                                end_date: e_date,
                                hasCustomTime: true
                            });

                        }
                        if (appVersion == 'v2') {
                            $state.go('supplierPanel.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: s_date,
                                end_date: e_date,
                                hasCustomTime: true
                            });

                        }


                        /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                         serviceItemId: serviceItemId,
                         timeSessionId: dialogData.id
                         });

                         window.open(url,'_blank');*/
                        //   window.open(url,'_self');

                    }

                    $ctrl.updateCapacity = function (value) {

                        $ctrl.dialogData.capacity = null;

                        if ($ctrl.dialogData.floatTime) {
                            $ctrl.dialogData.capacity = value;
                            $ctrl.upsertFloatTimeSession($ctrl.dialogData);
                        } else
                            TimingInfo.changeTimeSessionCapacity($ctrl.dialogData.id, value).get(function () {
                                dialogData.capacity = value;
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                                $ctrl.refreshTimingInfoMethod();
                            });
                        return true;
                    }
                    $ctrl.updateDiscount = function (value) {
                        if (data.floatTime) {
                            $ctrl.dialogData.discount = value;
                            $ctrl.upsertFloatTimeSession(data);
                        } else
                            TimingInfo.changeTimeSessionDiscount($ctrl.dialogData.id, value).get(function () {
                                dialogData.discount = value;
                                //   $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        return true;
                    }
                    $ctrl.gotoOrderBag = function (id) {
                        $mdDialog.hide();
                        $state.go('supplierPanel-v2.editOrderBag', {id: id});

                    }
                    $ctrl.changeEnable = function (data) {

                        //if(data.floatTime)
                        //{
                        data.enable = !data.enable;
                        $ctrl.upsertFloatTimeSession(data);
                        //}
                        //else
                        //TimingInfo.changeTimeSessionEnable(data.id).get(function () {
                        //    $ctrl.dialogData.enable = !$ctrl.dialogData.enable;
                        //    dialogData.enable = $ctrl.dialogData.enable;
                        //    dialogData.updateEvent();
                        //});
                    }
                    $ctrl.upsertFloatTimeSession = function (ev) {
                        ev.start_date = DateUtils.newDate(ev.start_date);
                        ev.end_date = new Date(ev.end_date);
                        ev.orderBagStatusList = [0, 1];
                        //      var timeSpan={startTime:new Date(ev.start_date),endTime: new Date( ev.end_date),serviceItemId:serviceId};
                        timingInfo.upsertFloatTimeSession().save(ev, function (result) {

                            $ctrl.refreshTimingInfoMethod();
                            $ctrl.cancelDialog();
                        });

                        onCratingNewEvent = false;

                    }
                    $ctrl.saveDialog = function (answer) {
                        dialogData.price = $ctrl.dialogData.price;
                        dialogData.discount = $ctrl.dialogData.discount;
                        dialogData.capacity = $ctrl.dialogData.capacity;
                        dialogData.enable = $ctrl.dialogData.enable;
                        dialogData.updateEvent();
                        $mdDialog.hide(answer);
                    };
                }
                TimeSessionDetailController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils'];


            }//end of link method
        }
    }]);
